import React, { useState, useEffect } from "react";
import axios from "axios";
import { addDays, differenceInDays, format, Locale, parseISO } from "date-fns";
import { enUS, fr, sv } from "date-fns/locale";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,

} from "@fortawesome/free-solid-svg-icons";
import { config } from "@fortawesome/fontawesome-svg-core";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { DateRange } from "../CRUD/CampSites/types";
import { addToCart } from "../ShoppingCart/addToCart";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//mport the custom hook
import ExchangeRates from "./ExhangeRates";
import LoadingSpinner from "../Utilities/LoadSpinner";


// Prevent FontAwesome from adding its CSS automatically
config.autoAddCss = false;

const localeMap: { [key: string]: Locale } = {
  "en-US": enUS,
  "fr-FR": fr,
  "sv-SE": sv,
  sv: sv, // Add short code for Swedish
  // Add more mappings as needed
};

interface BookingProps {
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
  cartItems: any[];
  setCartItems: (items: any[]) => void;
};

const packages = {
  winterAdventures: [
    { start: '2024-12-27', end: '2025-01-03', soldOut: true },
    { start: '2025-01-05', end: '2025-01-12' },
    { start: '2025-01-19', end: '2025-01-26' },
    { start: '2025-01-26', end: '2025-02-02' },
    { start: '2025-02-09', end: '2025-02-16' },
    { start: '2025-02-23', end: '2025-03-02' },
    { start: '2025-03-02', end: '2025-03-09' },
    { start: '2025-03-09', end: '2025-03-16' },
    { start: '2025-03-23', end: '2025-03-30' },
    { start: '2025-03-30', end: '2025-04-06' },
  ],
  catchTheArcticLight: [
    { start: '2024-11-16', end: '2024-11-23' },
    { start: '2025-01-18', end: '2025-01-25' },
  ],
  laplandALaCarte: [
    { start: '2025-02-02', end: '2025-02-09' },
    { start: '2025-02-16', end: '2025-02-23' },
    { start: '2025-03-16', end: '2025-03-23' },
  ],
  summerAdventures: [
    { start: '2025-06-21', end: '2025-06-28' },
    { start: '2025-07-12', end: '2025-07-19' },
    { start: '2025-08-02', end: '2025-08-09' },
    { start: '2025-08-16', end: '2025-08-23' },
  ],
  otherSummerAdventure: [
    { start: '2025-07-12', end: '2025-07-19' },
    { start: '2025-07-26', end: '2025-08-02' },
  ],
  ruska: [
    { start: '2025-08-30', end: '2025-09-06' },
    { start: '2025-09-06', end: '2025-09-13' },
  ],
};

const Booking: React.FC<BookingProps> = ({
  dateRange,
  setDateRange,
  cartItems,
  setCartItems,
}) => {
  const location = useLocation();
  const [availability, setAvailability] = useState<any[] | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [availabilityError, setAvailabilityError] = useState<string | null>(null);
  const [exampleCabins, setExampleCabins] = useState<any[] | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasCheckedAvailability, setHasCheckedAvailability] =
    useState<boolean>(false);
  const [locale, setLocale] = useState<Locale>(enUS);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [campsiteId, setCampsiteId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isCampsitesAvailable, setIsCampsitesAvailable] =
    useState<boolean>(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [exchangeRates, setExchangeRates] = useState<{ [key: string]: number }>(
    {}
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showExchangeRates, setShowExchangeRates] = useState(true); /// Use the custom hook
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalCost, setTotalCost] = useState<number>(0);

  useEffect(() => {
    const userLanguage = navigator.language || navigator.language;
    const userLocale =
      localeMap[userLanguage] || localeMap[userLanguage.split("-")[0]] || enUS;
    setLocale(userLocale);
  }, []);

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const response = await axios.get<{ rates: { [key: string]: number } }>(
          "https://api.exchangerate-api.com/v4/latest/EUR"
        );
        setExchangeRates(response.data.rates);
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    fetchExchangeRates();
  }, []);

  const getDynamicDates = (offsetDays = 21) => {
    const today = new Date();
    const arrivalDate = new Date(today);
    arrivalDate.setDate(today.getDate() + offsetDays);
  
    const departureDate = new Date(arrivalDate);
    departureDate.setDate(arrivalDate.getDate() + 7);
  
    return {
      arrivalDate: arrivalDate.toISOString(),
      departureDate: departureDate.toISOString(),
    };
  };

  const fetchExampleCabins = async (
    arrivalDate: string,
    departureDate: string,
    campsiteId?: number
  ) => {
    try {
      const response = await axios.get<{ data: any[] }>(
        `${process.env.REACT_APP_API_URL}/Booking/exampleCabins`,
        {
          params: {
            arrivalDate,
            departureDate,
            campsiteId,
          },
        }
      );
      const data = response.data as { data: any[] };
      console.log("Example Cabins:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error fetching example cabins:", error);
    }
  };
  const handleStartDateChange = (date: Date | null) => {
    if (date) {
      const startDay = date.getDay();
      if (startDay !== 6 && startDay !== 0) {
        setAvailabilityError('Start date must be a Saturday or Sunday.');
        return;
      }
      const endDate = addDays(date, 7);
      setDateRange({ startDate: date, endDate });
      setAvailabilityError(null);
    }
  };
  const checkAvailability = async (campSiteId?: number) => {
    if (dateRange.startDate && dateRange.endDate) {
      try {
        const formattedArrivalDate = dateRange.startDate.toISOString();
        const formattedDepartureDate = dateRange.endDate.toISOString();

        const params = {
          arrivalDate: formattedArrivalDate,
          departureDate: formattedDepartureDate,
          campSiteId: campSiteId,
        };

        if (campSiteId !== undefined && campSiteId !== null) {
          params.campSiteId = campSiteId;
          setCampsiteId(campSiteId);
        } else {
          setAvailability(null);
          setIsCampsitesAvailable(false);
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/Booking/availability`,
          { params }
        );

        const responseData = response.data as { data: any[] };
        console.log('Response Data:', responseData.data); // Log response data

        const daysDifference = differenceInDays(
          dateRange.endDate,
          dateRange.startDate
        );
        console.log('Days Difference:', daysDifference); // Log days difference

        if (responseData.data.length === 0) {
          setAvailability(null);
          setIsCampsitesAvailable(false);
        } else {
          const availabilityWithCosts = (response.data as { data: any[] }).data.map(
            (campsite: any) => {
              const totalCost = campsite.pricePerNight * daysDifference;
              console.log(`Total Cost for ${campsite.name}:`, totalCost); // Log total cost for each campsite
              return { ...campsite, totalCost };
            }
          );

          setAvailability(availabilityWithCosts);
          setIsCampsitesAvailable(true);

          console.log('Availability with Costs:', availabilityWithCosts);
        }
      } catch (error) {
        console.error('Error checking availability', error);
        setAvailability(null);
        setIsCampsitesAvailable(false);
      } finally {
        setHasCheckedAvailability(true); // Set the flag to true after checking availability
      }
    }
  };
  useEffect(() => {
    console.log("Total Cost:", totalCost);
  }, [totalCost]);

  const handleCheckAvailability = () => {
    setCampsiteId(null);
    checkAvailability();
  };
  

  const handleAddToCart = async (campSiteId: number) => {
    // Check if the campsite with the same dates is already in the cart
    const isAlreadyInCart = cartItems.some(
      (item) =>
        item.campSiteId === campSiteId &&
        item.arrivalDate === dateRange.startDate?.toISOString() &&
        item.departureDate === dateRange.endDate?.toISOString()
    );

    if (isAlreadyInCart) {
      console.log(
        "This campsite with the selected dates is already in the cart."
      );
      return; // Exit the function if the item is already in the cart
    }

    // Convert dates to UTC before sending to backend
    const startDateUTC = dateRange.startDate
      ? new Date(
          dateRange.startDate.getTime() -
            dateRange.startDate.getTimezoneOffset() * 60000
        ).toISOString()
      : "";
    const endDateUTC = dateRange.endDate
      ? new Date(
          dateRange.endDate.getTime() -
            dateRange.endDate.getTimezoneOffset() * 60000
        ).toISOString()
      : "";

    // Proceed with checking availability and adding to cart
    await checkAvailability(campSiteId);

    const updatedCart = await addToCart(campSiteId, startDateUTC, endDateUTC);
    if (updatedCart) {
      console.log("Item added to cart:", updatedCart);
      console.log("Selected Dates:", dateRange.startDate, dateRange.endDate);
      console.log("UTC Dates:", startDateUTC, endDateUTC);

      setCartItems(updatedCart.data); // Update the state with the new cart items
    }

    // Check availability again to update the list
    await checkAvailability();
  };

  useEffect(() => {
    if (location.state && location.state.dateRange) {
      setDateRange(location.state.dateRange);
      const campSiteId = location.state.campSiteId || null; // Assuming campSiteId is passed in location.state
      checkAvailability(campSiteId);
    }
    
  }, [location.state, setDateRange]);

  useEffect(() => {
    const loadExampleCabins = async (offsetDays = 21) => {
      setIsLoading(true); // Set loading state to true
      const { arrivalDate, departureDate } = getDynamicDates(offsetDays);
      const exampleCabins = await fetchExampleCabins(arrivalDate, departureDate);
      console.log("Example Cabins:", exampleCabins);

      if (exampleCabins && exampleCabins.length > 0) {
        setExampleCabins(exampleCabins);
        setDateRange({ startDate: new Date(arrivalDate), endDate: new Date(departureDate) });
      } else if (offsetDays < 60) { // Retry with a later date if no cabins are available and offsetDays is less than 60
        loadExampleCabins(offsetDays + 7);
      } else {
        console.log("No example cabins available for the next 60 days.");
      }
      setIsLoading(false); // Set loading state to false
    };

    if (!dateRange.startDate || !dateRange.endDate) {
      loadExampleCabins();
    }
  }, []);

  return (
    <>
   
      {showExchangeRates && <ExchangeRates baseCurrency="EUR" />}
      <div className="booking-section">
        <div className="booking-availability">
          <div className="form-group">
            <label htmlFor="dateRange">Arrival & Departure Dates</label>
            <div className="date-picker-wrapper">
              <FontAwesomeIcon
                icon={faCalendarAlt}
                className="fa-calendar custom-calendar-icon"
              />
             <DatePicker
                selected={dateRange.startDate}
                onChange={handleStartDateChange}
                startDate={dateRange.startDate ?? undefined}
                endDate={dateRange.endDate ?? undefined}
                selectsStart
                className="form-control"
                placeholderText="Select dates"
                dateFormat="EEE MMM d"
                locale={locale}
                calendarStartDay={1} // Start the calendar on Monday
                minDate={new Date()} // Disable past dates
                includeDates={Object.values(packages).flat().map(pkg => parseISO(pkg.start))}
              />
            </div>
            <button
              className="btn btn-primary check-avail-btn"
              onClick={handleCheckAvailability}
            >
              Check Availability
            </button>
          </div>
        </div>
      </div>
      <div className={`booking-section mb-5 pb-5`}>
        {isLoading ? (
          <LoadingSpinner />
        ) : availability && availability.length > 0 ? (
          <div className="booking mt-1">
            <h3>Available Cabins:</h3>
            <div className="row justify-content-center">
              {availability.map((site, index) => (
                <div
                  className="col-md-6 col-lg-4 d-flex justify-content-center mb-4"
                  key={index}
                >
                  <div className="card">
                    <div className="card-header">
                      <img
                        src={
                          site.imageUrls?.find((img: any) => img.isMain)?.url ||
                          "default-image-url.jpg"
                        }
                        className="card-img-top"
                        alt="Campsite"
                      />
                      <div>
                        <h5 className="card-title">{site.name}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {site.location}
                        </h6>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-text">
                        Capacity: {site.capacity} <br />
                        Price per night: €
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        })
                          .format(site.pricePerNight)
                          .replace("€", "")}
                      </div>
                      <div className="card-text">
                        Total Cost for{" "}
                        {dateRange.startDate && dateRange.endDate
                          ? differenceInDays(
                              dateRange.endDate,
                              dateRange.startDate
                            )
                          : 0}{" "}
                        nights: €
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        })
                          .format(site.totalCost)
                          .replace("€", "")}
                      </div>
                      <Link to={`/campsite/${site.id}`} state={{ dateRange }}>
                        <Button variant="info" className="me-1 mt-3">
                          View Details
                        </Button>
                      </Link>
                      <Button
                        variant="success"
                        className="mt-3"
                        onClick={() => handleAddToCart(site.id)}
                      >
                        Select
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : exampleCabins && exampleCabins.length > 0 ? (
          <div className="booking mt-1">
            <h3>Example Cabins:</h3>
            <div>
              <p>
                Following cabins are available for the selected dates:{" "}
                {dateRange.startDate
                  ? format(dateRange.startDate, "EEE MMM d", { locale })
                  : ""}{" "}
                -{" "}
                {dateRange.endDate
                  ? format(dateRange.endDate, "EEE MMM d", { locale })
                  : ""}{" "}
                <small>
                  Please <strong>Check Availability</strong> for more options
                </small>
              </p>
            </div>
            <div className="row justify-content-center">
              {exampleCabins.map((site, index) => (
                <div
                  className="col-md-6 col-lg-4 d-flex justify-content-center mb-4"
                  key={index}
                >
                  <div className="card">
                    <div className="card-header">
                      <img
                        src={
                          site.imageUrls?.find((img: any) => img.isMain)?.url ||
                          "default-image-url.jpg"
                        }
                        className="card-img-top"
                        alt="Campsite"
                      />
                      <div>
                        <h5 className="card-title">{site.name}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {site.location}
                        </h6>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-text">
                        Capacity: {site.capacity} <br />
                        Price per night: €
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        })
                          .format(site.pricePerNight)
                          .replace("€", "")}
                      </div>
                      <div className="card-text">
                        Total Cost for 7 nights: €
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        })
                          .format(site.pricePerNight * 7)
                          .replace("€", "")}
                      </div>

                      <Link to={`/campsite/${site.id}`} state={{ dateRange }}>
                        <Button variant="info" className="me-1 mt-3">
                          View Details
                        </Button>
                      </Link>
                      <Button
                        variant="success"
                        className="mt-3"
                        onClick={() => handleAddToCart(site.id)}
                      >
                        Select
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="booking mt-1">
            <h3>No more available cabins for the selected dates.</h3>
          </div>
        )}
      </div>
    </>
  );
};

export default Booking;
